var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MasterDetail',{ref:"masterDetail",attrs:{"canDelete":false,"cols":_vm.cols,"formTitle":"Nível hierarquico","hasExportCSV":false,"hasExportXLSX":false,"opts":_vm.opts,"resourceUrl":_vm.resourceUrl,"serverPagination":""}})}
var staticRenderFns = []

export { render, staticRenderFns }